export const API_URL = process.env.REACT_APP_API_URL || '';
export const HASURA_API_URL = process.env.REACT_APP_HASURA_API_URL || '';
export const HASURA_WEBSOCKET_URL = process.env.REACT_APP_HASURA_WEBSOCKET_URL || '';
export const FILE_UPLOAD_URL =
  process.env.REACT_APP_FILE_UPLOAD_URL ||
  'https://303fwa9484.execute-api.us-east-1.amazonaws.com/dev/file_upload';
